export interface ActionLink {
  href: string;
  /** A link to another origin opens in a new tab. A path or the page's own origin opens in this one. */
  newTab: boolean;
}

/**
 * The notifications table only holds an https address or a path with one leading slash.
 * The browser checks again, so a row written around the table rules cannot run a script.
 */
export function resolveActionLink(url: string, pageOrigin: string = window.location.origin): ActionLink | null {
  // The URL parser drops a tab or newline, so '/<TAB>/host' would become '//host'.
  if (Array.from(url).some((char) => char.charCodeAt(0) <= 0x20 || char.charCodeAt(0) === 0x7f)) return null;

  if (/^\/(?![/\\])/.test(url)) return { href: url, newTab: false };

  try {
    const parsed = new URL(url);
    if (parsed.protocol !== 'https:') return null;
    return { href: parsed.href, newTab: parsed.origin !== pageOrigin };
  } catch {
    return null;
  }
}
